import { render, staticRenderFns } from "./MemberCallSearch.vue?vue&type=template&id=98baf984&"
import script from "./MemberCallSearch.vue?vue&type=script&lang=ts&"
export * from "./MemberCallSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports